import { useState, useEffect } from 'preact/hooks';
import { apiFetch } from '../../services/api';

interface VisionModalProps {
  mediaUrl: string | null;
  content: string;
  messageId?: string;
  onClose: () => void;
}

export function VisionModal({ mediaUrl, content, messageId, onClose }: VisionModalProps) {
  const [analysisText, setAnalysisText] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (mediaUrl) {
      runVisionAnalysis();
    }
  }, [mediaUrl, messageId]);

  const runVisionAnalysis = async () => {
    if (!mediaUrl) return;
    setLoading(true);
    try {
      let text = '';
      if (messageId) {
        const data = await apiFetch<{ extractedText?: string; error?: string }>(`/messages/${messageId}/transcribe`, {
          method: 'POST'
        });
        text = data.extractedText || '';
      } else {
        const data = await apiFetch<{ analysis?: string; error?: string }>('/ai/vision-analyze', {
          method: 'POST',
          body: JSON.stringify({ mediaUrl, context: content })
        });
        text = data.analysis || '';
      }

      if (text) {
        setAnalysisText(text);
      } else {
        setAnalysisText('Nenhum texto ou análise foi retornado.');
      }
    } catch (err: any) {
      setAnalysisText(`Erro ao analisar imagem: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (!mediaUrl) return null;

  return (
    <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-950/85 backdrop-blur-md animate-fade-in">
      <div
        class="w-full max-w-2xl p-6 bg-slate-900 border border-slate-800 rounded-3xl shadow-2xl space-y-4 max-h-[90vh] flex flex-col"
        style={{ backgroundColor: '#0f172a' }}
      >
        <div class="flex items-center justify-between border-b border-slate-800 pb-3 flex-shrink-0">
          <h3 class="text-sm font-bold text-slate-100 flex items-center gap-2">
            🔍 Análise de Conteúdo Visual
          </h3>
          <button onClick={onClose} class="text-slate-400 hover:text-white p-1 cursor-pointer">
            ✕
          </button>
        </div>

        <div class="flex-1 overflow-y-auto space-y-4 pr-1">
          <div class="flex justify-center">
            <img src={mediaUrl} alt="Visualização" class="max-h-72 object-contain rounded-xl border border-slate-800" />
          </div>

          <div class="p-4 bg-slate-950/90 rounded-2xl border border-slate-800 text-xs space-y-2">
            <span class="text-[10px] font-bold uppercase tracking-wider text-cyan-400 block">
              Resultado da Análise Visual:
            </span>
            {loading ? (
              <div class="p-4 text-center text-slate-400 font-mono animate-pulse">
                Analisando e examinando os elementos da imagem...
              </div>
            ) : (
              <p class="whitespace-pre-wrap text-slate-200 leading-relaxed">{analysisText}</p>
            )}
          </div>
        </div>

        <div class="flex justify-end pt-2 border-t border-slate-800 flex-shrink-0">
          <button
            onClick={onClose}
            class="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-slate-300 text-xs font-bold rounded-xl"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}
